import AppItemsIndex from "./item.vue";
import AppItemsList from "./list/list.vue";
import AppItemsItem from "./item/item.vue";

const routes = [
  {
    path: "/item",
    component: AppItemsIndex,
    meta: {
      auth: {
        roles: "item.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "item.index",
        component: AppItemsList,
        meta: {
          auth: {
            roles: "item.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "item.create",
        component: AppItemsItem,
        meta: {
          auth: {
            roles: "item.create",
            redirect: { name: "item.index" }
          }
        }
      },
      {
        path: ":id",
        name: "item.edit",
        component: AppItemsItem,
        meta: {
          auth: {
            roles: "item.update",
            redirect: { name: "item.index" }
          }
        }
      }
    ]
  }
];

export default routes;
